import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["IframeDemo"] */ "/build/src/components/pages/internet-of-cognition/explore/iframe-demo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpactSection"] */ "/build/src/components/pages/internet-of-cognition/explore/impact-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourcesSection"] */ "/build/src/components/pages/internet-of-cognition/explore/resources-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimplifiedV2"] */ "/build/src/components/pages/internet-of-cognition/explore/SimplifiedV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/topic-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/build/src/components/ui/aspect-ratio.tsx");
